import ApiService from '@/services/core/api.service'

const BarangayService = {
  async get (query) {
    return ApiService.get(`admin/barangays?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/barangays', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/barangays/${payload.id}`, payload)
  }
}

export default BarangayService
